import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid } from '@mui/material';

import { getProductManagement } from 'api/products';
import { API } from 'axiosClient/config';
import PageContentLayout from 'components/layout/PageContentLayout';
import SetPageTitle from 'components/common/SetPageTitle';
import normalizeCountriesResponse from 'utils/normalizers/api/normalizeCountriesResponse';

import CountriesTable from './CountriesTable';
import SearchInput from 'components/common/SearchInput';
import paths from 'routes/paths';

const CountriesListing = () => {
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [filteredRows, setFilteredRows] = useState(null);
  const history = useHistory();

  const getTitle = () => 'Countries';

  const fetchCountries = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getProductManagement(API.products.countries);
      const normalizedCountries = normalizeCountriesResponse(
        response.data.data,
      );
      setCountries(normalizedCountries);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      throw e;
    }
  }, []);

  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  const handleNewGame = () =>
    history.push(paths.eCommerceConfiguration.countries.create);

  const filterCountriesByIdOrName = (value) => {
    if (!value?.length) {
      setFilteredRows(null);
    }

    const filteredCountries = countries.filter(
      (country) =>
        country.id?.toLowerCase()?.includes(value.toLowerCase()) ||
        country.name?.toLowerCase()?.includes(value.toLowerCase()),
    );

    setFilteredRows(filteredCountries);
  };

  return (
    <>
      <SetPageTitle pageTitle={getTitle()} />
      <PageContentLayout
        title={getTitle()}
        isLoading={loading}
        buttons={[
          {
            label: 'Add a new Country',
            onClick: handleNewGame,
          },
        ]}
      >
        <Grid container>
          <Grid item xs={12}>
            <SearchInput
              onSubmit={(val) => filterCountriesByIdOrName(val)}
              placeholder="Search for a country"
            />
          </Grid>
          <Grid item xs={12}>
            <CountriesTable
              rows={filteredRows || countries || []}
              isLoading={loading}
              disablePagination={true}
              rowCount={countries && countries.length}
            />
          </Grid>
        </Grid>
      </PageContentLayout>
    </>
  );
};

export default CountriesListing;
